interface Props {
  label: string;
  value: string | number;
  sub?: string;
}

export function StatCard({ label, value, sub }: Props) {
  return (
    <div className="bg-surface border border-border rounded-lg px-4 py-3">
      <div className="text-2xl font-bold text-accent-2">{value}</div>
      <div className="text-[11px] text-zinc-500 mt-0.5">{label}</div>
      {sub && <div className="text-[10px] text-zinc-600 mt-0.5">{sub}</div>}
    </div>
  );
}
